module Shared.Admin.DisableUser

open Shared
open Illy.SafeStack

type DTO = 
    {
        UserId: int 
        Reason: string option
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations
    
    type DisableValidations = 
        | ReasonValidations of StringValidations
        | CannotDisableOwnUser

    module DisableValidations = 
        let toString = 
            function 
            | ReasonValidations v -> v.toString()
            | CannotDisableOwnUser -> "Cannot disable your own user account."
    
    let validateDTO currentUserId dto = 
        validate {
            return! (validateString 500 true >-> DisableValidations.ReasonValidations) dto.Reason
            
            return! !!(error CannotDisableOwnUser)
                >>= conditional pass (fun _ -> UserId dto.UserId <> currentUserId)
                |> unwrap
        }

type FailureReason = 
    | NothingToDo
    | FailedValidations of Validation.ValidationResult<Validations.DisableValidations, Validation.NoWarning>